import { CdkService, MileageUnit, UpdateOdometerReadingVehicleRequest } from 'api-new/generated';
import { QueryError } from 'features/shared/model';
import { UseMutationOptions, useMutation } from 'react-query';

export type UpdateVehicleOdometerInput = {
  branchId: number;
  vehicleId: string;
  mileageValue: number;
};

const CDK_AUDIT_DATA = {
  userId: 'api-1588',
  userName: 'QS API'
};

export const useUpdateVehicleOdometerMutation = (
  options?: Omit<
    UseMutationOptions<
      Awaited<ReturnType<typeof CdkService.postCdkVehiclesVehicleUpdateOdometer>>,
      QueryError,
      UpdateVehicleOdometerInput,
      unknown
    >,
    'mutationFn'
  >
) =>
  useMutation((input: UpdateVehicleOdometerInput) => {
    const requestBody: UpdateOdometerReadingVehicleRequest = {
      metadata: {
        auditData: CDK_AUDIT_DATA
      },
      odometerReading: {
        unit: MileageUnit.MILES,
        value: input.mileageValue
      }
    } as any;
    return CdkService.postCdkVehiclesVehicleUpdateOdometer(input.branchId, input.vehicleId, {
      ...requestBody
    });
  }, options);
